export default __webpack_public_path__ + "static/media/he.js.52dbcca7.map";